import { minAbbrNumberFilter, percentageSignFilter } from "app/filters/ngFilters";
import { getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { IActivationSetCellEnrichedResponse, IActivationSetCellEnrichedTransformed } from "./types";

export const transformEnrichedCellData = (
    response: IActivationSetCellEnrichedResponse,
): IActivationSetCellEnrichedTransformed => {
    const params = proNavigator.getParams();

    const data = response?.data?.map((row) => ({
        ...row,
        domain: {
            domain: row.domain,
            favicon: row.favicon,
            internalLink: proNavigator.href("digitalsuite_website_websiteperformance", {
                key: row.domain,
                country: params.country as string,
                duration: params.duration as string,
                webSource: params.webSource as string,
                isWWW: params.includeSubDomains ? "*" : "-",
            }),
        },
        clicks: minAbbrNumberFilter()(getVolumeValue(row.clicks), 50),
        share: percentageSignFilter()(row.share),
    }));
    // @ts-expect-error FIXME: Types of property 'share' are incompatible.
    return { data, totalCount: response?.totalCount };
};
